import React from 'react';
import { useHistory } from 'react-router-dom';
import { ProfileQL } from '../../models/Profile';
import ProfileAvatar from '../visuals/avatar';

import './accountAvatarHolder.scss';

interface AccountAvatarHolderProps {
    currentUser: ProfileQL;
    hideName?: boolean;
}

const AccountAvatarHolder = ({ currentUser, hideName = false }: AccountAvatarHolderProps) => {
    const history = useHistory();

    const goToPlanes = () => {
        if(currentUser.billing?.isClusterType) {
            // "Gestor" types should not upgrade
            return
        }
        history.push({
            pathname: '/planes'
        })
    }

    return (
        <div className="salut">
            <div className="avatarHolder">
                <ProfileAvatar currentUser={currentUser} absolute={true} />
            </div>
            {!hideName && (
                <div className="whois">
                    <h1>¡Hola {currentUser.professionalProfile.companyName}! </h1>
                </div>
            )}
            <div className="planInfo">
                <div className={`planType`} onClick={goToPlanes}>
                    <span>FiscalPOP Personal</span>
                </div>
            </div>
        </div>
    )
}

export default AccountAvatarHolder;